export default __webpack_public_path__ + "static/media/template19.7b31ccc1.svg";